import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { createSelector } from 'reselect';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { Card, CardHeader, CardBody } from "reactstrap";
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import Preloader from '../../Components/Common/Preloader';
import { createAnalytics, createBrandAnalytics, createClientAnalytics, createCreativeAnalytics, createMarketAnalytics } from '../../slices/analytics/thunk';
import { setAnalyticsPreloader, setSelectedBrandId, setSelectedCampaignId, setSelectedClientId, setSelectedMarketId } from '../../slices/analytics/reducer';
import { push, replace } from 'redux-first-history';
import { setBrandPath, setClientPath, setMarketPath } from '../../slices/auth/menu/thunk';
import { setCampaignPath } from '../../slices/auth/menu/reducer';

function ChildTable() {
  const dispatch = useDispatch();
  const params = useParams();

  const selectState = createSelector(state => state, state => ({
    client: state.MenuData.client,
    childTableLoader: state.Analytics.childTableLoader,
    childTableData: state.Analytics.childTableData,
    selectedClientId: state.Analytics.selectedClientId,
    selectedBrandId: state.Analytics.selectedBrandId,
    selectedMarketId: state.Analytics.selectedMarketId,
    selectedCampaignId: state.Analytics.selectedCampaignId,
  }));
  const { client, childTableLoader, childTableData, selectedClientId, selectedBrandId, selectedMarketId, selectedCampaignId } = useSelector(selectState);
 
  const tableRef = useRef();
  useEffect(() => {
    if (childTableData?.data) {
      try {
        const table = $(tableRef.current).DataTable({
          data: childTableData.data,
          columns: [
            {
              data: 'name',
              title: 'Name',
              render: (data, type, row) => {
                return `<p class="name text-decoration-underline text-danger m-0">${data}</p>`
              }
            },
            {
              data: 'impression',
              title: 'Impressions'
            },
            {
              data: 'click',
              title: 'Clicks'
            },
            {
              data: 'ctr',
              title: 'CTR'
            }
          ],
          responsive: true,
          destroy: true,
          searching: false,
          paging: true,
          info: false,
          sortable: false
        });
        tableRef.current.parentElement.parentElement.parentElement.querySelector('.row').style.display = 'none';

        table.on("click", ".name", async function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            let path = '';
            if (selectedClientId === '1' || selectedClientId === null || selectedClientId === undefined) {
              dispatch(setClientPath(data.id));
              dispatch(setSelectedClientId(data.id));
              dispatch(setBrandPath(null));
              dispatch(setSelectedBrandId(null));
              dispatch(setMarketPath(null));
              dispatch(setSelectedMarketId(null));
              dispatch(setCampaignPath(null));
              dispatch(setSelectedCampaignId(null));
            } else if (selectedBrandId === '1' || selectedBrandId === undefined || selectedBrandId === null) {
              dispatch(setBrandPath(data.id));
              dispatch(setSelectedBrandId(data.id));
              dispatch(setMarketPath(null));
              dispatch(setSelectedMarketId(null));
              dispatch(setCampaignPath(null));
              dispatch(setSelectedCampaignId(null));
            } else if (selectedMarketId === '1' || selectedMarketId === undefined || selectedMarketId === null) {
              dispatch(setMarketPath(data.id));
              dispatch(setSelectedMarketId(data.id));
              dispatch(setCampaignPath(null));
              dispatch(setSelectedCampaignId(null));            
            } else if (selectedCampaignId === '1' || selectedCampaignId === undefined || selectedCampaignId === null) { 
              dispatch(setCampaignPath(data.id));
              dispatch(setSelectedCampaignId(data.id));        
            } else {
              return;
            }
            dispatch(setAnalyticsPreloader(true));
            setTimeout(() => {
              dispatch(createAnalytics(true));
            }, 1);
          }
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
        // console.log(error);
      }
    }
  }, [childTableData]);
  return (
    <React.Fragment>
      {childTableLoader ?
        <Card className='card card-height-100 align-items-center justify-content-center'>
          <Preloader isComponentLoader={true} width={150} height={150} />
        </Card>
        :
        <Card className='card card-height-100'>
          <CardHeader className='card-header align-items-center d-flex justify-content-between'>
            {childTableData && childTableData?.title ? <p className='m-0'>{childTableData.title}</p> : null}
            {/* {brand &&
              <ol className='breadcrumb mb-0'>
                <li className='breadcrumb-item active'>{brand.charAt(0).toUpperCase() + brand.slice(1)}</li>
                {market && <li className='breadcrumb-item'><Link to=' '>{market.toUpperCase()}</Link></li>}
              </ol>
            } */}
          </CardHeader>
          <CardBody className='pt-0'>
            <div className='table-responsive table-card mt-0'>
              <table
                className="align-middle table-nowrap mb-0 table"
                style={{ width: "100%" }}
                ref={tableRef}
              >
                <thead className="table-light"></thead>
                <tbody></tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      }

    </React.Fragment>

  )
}

export default ChildTable;